import { Injectable } from '@angular/core';

import {BehaviorSubject, Observable} from "rxjs";
import {filter, mapTo} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EventService {

  private _eventData: BehaviorSubject<[string, any]>;
  constructor() {
    this._eventData = new BehaviorSubject<[string, any]>(['key','value']);
  }

  emitEvent(nextEvent:[string, any]){
    this._eventData.next(nextEvent)
  }

  addListener(key:string): Observable<any>{
    return this._eventData.pipe(
      filter(data=> data[0]==key),
      mapTo((data1:any)=> data1[1])
    )
  }
}
